import { createContext } from "react"
import { LanguageContextProps } from "../types"
import { DEFAULT_LOCALE } from "@/config/locales"

export const LanguageContext = createContext<LanguageContextProps>({
    locale: DEFAULT_LOCALE,
    handleAppLocale: () => {},
})
